import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@ff/ui/Icon';

// react stateless component
const FFLogo = ({ color, size, type, clickable, link }) => {
  let logo = null;

  if (type === 'simple' || !type) {
    logo = <Icon name="ff-icon-logo" fontSize={size} color={color} />;
  } else if (type === 'full') {
    logo = <Icon name="ff-icon-logo-full-black" fontSize={size} color={color} />;
  }

  return (
    clickable ? (
      <a href={link} style={{ textDecoration: 'none' }}>
        {logo}
      </a>
    ) : logo
  );
};

FFLogo.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  type: PropTypes.string,
  clickable: PropTypes.bool,
  link: PropTypes.string
};

FFLogo.defaultProps = {
  color: 'black',
  size: '30px',
  type: 'simple',
  clickable: 'false',
  link: ''
};

export default FFLogo;
